import { Component, OnInit, ViewChild } from '@angular/core';
import { TabDirective, TabsetComponent } from 'ngx-bootstrap/tabs/public_api';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-Awards',
  templateUrl: './Awards.component.html',
  styleUrls: ['./Awards.component.scss']
})
export class AwardsComponent implements OnInit {

  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  id: number;
  tab = 'Achievements';
  enable: boolean = true;
  randomBool: boolean = true;

  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
  }

  constructor() { }

  onSelect(data: TabDirective): void {
    this.tab = data.heading;
    console.log('tab ' + this.tab);

  }

  ngOnInit() {
  }

}
